module.exports = __webpack_public_path__ + "img/272.5f25bf85.gif";